import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";

import styles from "./HelpNavigation.module.scss";
import { IconButton, Popover, MenuList, MenuItem } from "@material-ui/core";
import {
  HelpOutline,
  RateReviewOutlined,
  AssignmentOutlined,
} from "@material-ui/icons";
import HelpCenterIcon from "./HelpCenterIcon";
import makeStyles from "@material-ui/styles/makeStyles";
import HelpNavigationModal from "./HelpNavigationModal";
import { getLocalValue } from "../../utils/auth";
import AuthApi from "../../context/AuthApi";

const menu = [
  {
    id: "Help Center",
    icon: HelpCenterIcon,
    urlLink: "https://flashcoach.zendesk.com/",
    isExternalUrl: true,
    shouldDisplayAsModal: false,
  },
  {
    id: "Help Request Form",
    icon: RateReviewOutlined,
    urlLink: `/help-request/new/form`,
    isExternalUrl: false,
    shouldDisplayAsModal: false,
  },
  {
    id: "User Feedback Survey",
    icon: AssignmentOutlined,
    urlLink: "/user-feedback",
    isExternalUrl: false,
    shouldDisplayAsModal: true,
  },
];

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiMenuItem-root": {
      maxHeight: "40px",
    },
  },
}));

const HelpNavigation = () => {
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [modalComponentID, setModalComponentID] = useState(null);
  const [key, setKey] = useState("");

  const classes = useStyles();
  const Auth = useContext(AuthApi);

  useEffect(() => {
    const accessToken = getLocalValue("access_token");
    const key = accessToken?.split(".")[0];
    setKey(key);
  }, [Auth]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuNavigation = ({ urlLink, displayAsModal, id, isExternalUrl }) => {
    if (isExternalUrl) {
      return window.open(urlLink, "_blank");
    }
    if (!displayAsModal) {
      return history.push(urlLink);
    }
    setShouldShowModal(previousState => !previousState);
    setModalComponentID(id);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-support" : undefined;
  return (
    <>
      <IconButton
        onClick={handleClick}
        color="secondary"
        aria-label="open help dropdown navigation"
      >
        <HelpOutline className={styles.helpIcon} fontSize="medium" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={4}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuList className={classes.root}>
          {menu &&
            menu.length > 0 &&
            menu.map(item => {
              const MenuIcon = item.icon;
              return (
                <MenuItem
                  key={item.id}
                  onClick={() =>
                    handleMenuNavigation({
                      urlLink: key && key !== "" && item.id === "Help Request Form"
                        ? `/help-request/${key}/form`
                        : item.urlLink,
                      displayAsModal: item.shouldDisplayAsModal,
                      id: item.id,
                      isExternalUrl: item.isExternalUrl
                    })
                  }
                >
                  <MenuIcon className={styles.menuIcon} />
                  <p className={styles.navigationText}>{item.id}</p>
                </MenuItem>
              );
            })}
        </MenuList>
      </Popover>
      {shouldShowModal && (
        <HelpNavigationModal
          shouldShowModal={shouldShowModal}
          setShouldShowModal={setShouldShowModal}
          modalComponentID={modalComponentID}
        />
      )}
    </>
  );
};

export default HelpNavigation;
